// Libraries
import React from 'react';

// Supermove
import {DataLoader, Space, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useNavigationDOM, useResponsive, useQuery, useToast} from '@supermove/hooks';
import {UserModel} from '@supermove/models';

// App
import Button from '@shared/design/components/Button';
import Text from '@shared/design/components/Text';
import SuccessToast from '@shared/design/components/Toast/SuccessToast';
import StageForm from '@shared/modules/Project/forms/StageForm';
import useCreateStageMutation from '@shared/modules/Project/hooks/useCreateStageMutation';
import AddStagePageContent from '@shared/modules/Sales/components/AddStagePageContent';
import EditStageFields from '@shared/modules/Sales/components/EditStageFields';
import ProjectSettingsPage from 'modules/Organization/Settings/Project/ProjectSettingsPage';

const ContentContainer = Styled.View`
  padding-horizontal: 24px;
  max-width: 520px;
`;

const NewSalesStagePageContent = ({viewer}: {viewer: UserModel}) => {
  const {navigator, params} = useNavigationDOM();
  const successToast = useToast({ToastComponent: SuccessToast});

  const organizationId = viewer.viewingOrganization?.id;

  const stageForm = StageForm.new({
    organizationId,
    projectStatus: params.projectStatus,
  });

  const {form, submitting, handleSubmit} = useCreateStageMutation({
    stageForm,
    onSuccess: () => {
      successToast.handleToast({message: 'Sales stage created.'});
      navigator.push('/settings/projects/stages');
    },
    onError: (errors) => console.log({errors}),
  });

  return (
    <React.Fragment>
      <EditStageFields form={form} />
      <Space height={24} />
      <Button
        text={'Save'}
        onPress={handleSubmit}
        isSubmitting={submitting}
        style={{width: '100%'}}
        isWidthOfContainer
      />
    </React.Fragment>
  );
};

const NewSalesStagePage = () => {
  const {navigator, params} = useNavigationDOM();
  const responsive = useResponsive();

  const {loading, data} = useQuery<{viewer: UserModel}>(AddStagePageContent.query, {
    fetchPolicy: 'cache-and-network',
  });

  return (
    <ProjectSettingsPage
      title={''}
      description={''}
      breadcrumbs={[
        {name: 'Settings', onPress: () => navigator.push('/settings')},
        {name: 'Projects', onPress: () => navigator.push('/settings/projects/stages')},
        {name: 'New Sales Stage'},
      ]}
      isCompanySettings
    >
      <ContentContainer>
        <Space height={responsive.desktop ? 24 : 16} />
        <Text.PageHeading>Overview</Text.PageHeading>
        <Space height={24} />
        <DataLoader loading={loading} data={data}>
          {({loadedData}) => {
            return <NewSalesStagePageContent viewer={loadedData.viewer} />;
          }}
        </DataLoader>
      </ContentContainer>
    </ProjectSettingsPage>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
NewSalesStagePage.query = gql`
  query AddStagePageContent {
    ${gql.query}
    viewer {
      id
      viewingOrganization {
        id
      }
    }
  }
`;

export default NewSalesStagePage;
